// export const Api = "http://localhost:8000";
export const Api = "https://real-estate-db.glitch.me";
